import React, { useState, useEffect } from "react";
import { inject, observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "mobx-react-lite/batchingOptOut";

const StripeForm = inject("context")(
	observer(({ quoteForPayment, clientSecret, context }) => {
		const [succeeded, setSucceeded] = useState(false);
		const [error, setError] = useState(null);
		const [processing, setProcessing] = useState(false);
		const [disabled, setDisabled] = useState(true);
		//const [clientSecret, setClientSecret] = useState("");
		const stripe = useStripe();
		const elements = useElements();

		let history = useHistory();

		const amount = Math.round((quoteForPayment.total + Number.EPSILON) * 100);

		const BASE_API_URL = process.env.INSURFORCE_BASE_API_URL;


		const cardStyle = {
			style: {
				base: {
					color: "#32325d",
					fontFamily: "Arial, sans-serif",
					fontSmoothing: "antialiased",
					fontSize: "16px",
					"::placeholder": {
						color: "#32325d",
					},
				},
				invalid: {
					color: "#fa755a",
					iconColor: "#fa755a",
				},
			},
		};

		const handleChange = async (event) => {
			// Listen for changes in the CardElement
			// and display any errors as the customer types their card details
			setDisabled(event.empty);
			setError(event.error ? event.error.message : "");
		};

		const completePayment = (payload) => {
			// Define variables for service actions based on payment purpose.
			let serviceAction;
			const { insuranceQuotingService, insuranceRenewalsService, insuranceMtaService } = context;

			// Determine the action based on the payment purpose.
			switch (quoteForPayment.stripePaymentPurpose) {
				case "RENEWAL":
					serviceAction = insuranceRenewalsService.confirmInsuranceRenewal;
					break;
				case "QUOTE":
					serviceAction = insuranceMtaService.confirmInsuranceMta;
					break;
				default:
					// Optional: Handle other cases or set a default action.
					serviceAction = null; // Example: () => Promise.reject(new Error("Invalid payment purpose"));
			}

			// Perform the action if defined.
			if (serviceAction) {
				fetch(`${BASE_API_URL}/api/v1/payment-intent/status`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(payload),
				})
					.then(res => {
						if (res.ok) {
							// Execute the service action (confirm renewal or MTA).
							serviceAction().then(() => {
								history.push("/thank-you");
							});
						} else {
							// Handle server response error.
							setError("Server responded with an error. Please try again.");
							setProcessing(false);
						}
					})
					.catch(err => {
						console.log(err);
						setError("An error occurred while confirming payment. Please try again.");
						setProcessing(false);
					});
			} else {
				// Handle case where no action is defined for the payment purpose.
				console.error("No action defined for this payment purpose.");
				setError("An error occurred. Payment purpose not supported.");
				setProcessing(false);
			}
		};


		const handleSubmit = async (ev) => {
			ev.preventDefault();
			setProcessing(true);

			const payload = await stripe.confirmCardPayment(clientSecret, {
				payment_method: {
					card: elements.getElement(CardElement),
					billing_details: {
						name: ev.target.name.value,
					},
				},
			});
			if (payload.error) {
				setError(`Payment failed ${payload.error.message}`);
				setProcessing(false);
			} else {
				setError(null);
				setProcessing(false);
				setSucceeded(true);
				completePayment(payload);

			}
		};

		return (
			<form
				id="payment-form"
				onSubmit={handleSubmit}
				className="form-stripe-payment"
				style={{ width: "50%" }}
			>
				<CardElement
					id="card-element"
					options={cardStyle}
					onChange={handleChange}
				/>
				<button
					disabled={processing || disabled || succeeded}
					id="submit"
					className="button-paynow"
				>
					<span id="button-text">
						{processing ? <div className="spinner" id="spinner" /> : "Pay Now"}
					</span>
				</button>
				{/* Show any error that happens when processing the payment */}
				{error && (
					<div className="card-error" role="alert">
						{error}
					</div>
				)}


			</form>
		);
	})
);

export default StripeForm;
